/**
 * Related to Form Submission
 */
jQuery(document).ready(function ($) {
  function bindFormSuccessEvents() {
    console.log('bindFormSuccessEvents: attaching handler');
    $('#newcontactform')
      .off('submit_success')
      .on('submit_success', function (event, response) {
        let $form = $(this); // Get the form element

        // Hide the form smoothly and show a success message
        $form.fadeOut(500, function () {
          // show the hidden success message
          $('.contact_us_form_success_message_hidden')
            .css({ display: 'flex', opacity: 0 })
            .animate({ opacity: 1 }, 500)
            .after(function () {
              // slide the container upwards and centre it
              $('.contact_us_form_success_message_hidden').addClass('centered'); // CSS transition does the animation

              // keep the message visible for 10seconds
              setTimeout(function () {
                // hide the message and bring the form back
                $('.contact_us_form_success_message_hidden').fadeOut(500, function () {
                  // reset container position before showing the form again
                  $('.contact_us_form_success_message_hidden').removeClass('centered');

                  $form.fadeIn(500);
                });
              }, 10000); // 10000ms = 10seconds
            });
        });
      });

    $('#newcontactform2')
      .off('submit_success')
      .on('submit_success', function (event, response) {
        let $form = $(this); // Get the form element

        // Hide the form smoothly and show a success message
        $form.fadeOut(500, function () {
          // show the hidden success message
          $('.contact_us_form_success_message_hidden')
            .css({ display: 'flex', opacity: 0 })
            .animate({ opacity: 1 }, 500)
            .after(function () {
              // slide the container upwards and centre it
              $('.contact_us_form_success_message_hidden').addClass('centered'); // CSS transition does the animation

              // keep the message visible for 10seconds
              // setTimeout(function () {
              //   // hide the message and bring the form back
              //   $('.contact_us_form_success_message_hidden').fadeOut(500, function () {
              //
              //     // reset container position before showing the form again
              //     $('.contact_us_form_success_message_hidden').removeClass('centered');
              //
              //     $form.fadeIn(500);
              //   });
              // }, 10000); // 10000ms = 10seconds
            });
        });
      });
  }

  bindFormSuccessEvents();
});
